import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TransactionRequestEtisalatInputParamsModel, TransactionRequestPayWCreditCardInputParamsModel, TransactionRequestPayWDefinedCardInputParamsModel } from 'src/app/card-operations-core/models/transaction-request-models';
import { PaymentTypeModel } from 'src/app/card-operations/models/paymenType.model';

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.css']
})
export class TransactionsComponent implements OnInit {
  @Input() paymentType!: PaymentTypeModel;
  @Input() creditCardRequiredParams!: TransactionRequestPayWCreditCardInputParamsModel;
  @Input() definedCardParams!: TransactionRequestPayWDefinedCardInputParamsModel;
  @Input() etisalatRequiredParams!: TransactionRequestEtisalatInputParamsModel;
  
  @Output() onError = new EventEmitter();

  constructor() { }

  ngOnInit(): void {}
  
  onErrorReceive(){
    this.onError.emit();
  }

}
